<template>
  <q-r-code
    :value="value"
    :size="size"
    :margin="margin"
    :logo-src="logoSrc"
  />
</template>

<script>
import QRCode from './qrcode-@TIP_PLATFORM_NAME';
export default {
  components: {
    QRCode,
  },
  props: {
    value: {    // 二维码url
      type: String,
      default: '',
      required: true,
    },
    size: { // 二维码尺寸，单位px
      type: Number,
      default: 230,
      required: false,
    },
    margin: {
      type: Number,
      default: 0,
    },
    logoSrc: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
